export default __webpack_public_path__ + "static/media/forgetpass2.3dbac567.jpg";